var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import slice from 'lodash/slice';
import * as React from 'react';
import Breadcrumb from '../breadcrumb';
import BreadcrumbDivider from '../breadcrumb/divider';
import BreadcrumbSection from '../breadcrumb/section';
import Button from '../button';
import Icon from '../icon';
import { CloseButtonPosition, ModalSize } from '../modal/index';
import { Styled } from '../modal/style';
var NavigationControllerModal = /** @class */ (function (_super) {
    __extends(NavigationControllerModal, _super);
    function NavigationControllerModal(props) {
        var _this = _super.call(this, props) || this;
        _this.initRootView = function () {
            var elements = React.Children.map(_this.props.children, function (view) { return React.cloneElement(view, __assign({ router: _this })); });
            _this.setState({
                views: [
                    {
                        className: _this.props.className,
                        disableTitle: _this.props.disableTitle,
                        element: elements,
                        overflow: _this.props.overflow,
                        customHeader: _this.props.customHeader,
                        title: _this.props.title,
                        closeOnDimmerClick: _this.props.closeOnDimmerClick,
                        disableCloseButton: _this.props.disableCloseButton,
                    },
                ],
            });
        };
        _this.open = function () {
            if (_this.props.onOpen) {
                _this.props.onOpen();
                disableBodyScroll(_this.targetElement);
            }
            _this.setState({
                modalControl: 'md-modal md-show',
            });
        };
        _this.close = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
                document.body.classList.remove('md-open');
                enableBodyScroll(_this.targetElement);
            }
            _this.setState({
                modalControl: 'md-modal',
            });
        };
        _this.handleKeyPress = function (event) {
            var keyEvent = event.key;
            if (keyEvent === 'Escape') {
                _this.close();
            }
        };
        _this.getComponentViews = function () { return _this.state.views; };
        _this.gotoRoot = function () {
            _this.goto(0);
        };
        _this.goto = function (index) {
            var views = _this.state.views;
            if (index < 0 || index > views.length) {
                throw new Error('this view is not exists');
            }
            var newViews = slice(views, 0, index + 1);
            _this.setState({
                views: newViews,
            });
        };
        _this.goBack = function () {
            var views = __spreadArrays(_this.state.views);
            views.pop();
            _this.setState({
                views: views,
            });
        };
        _this.gotoComponentByName = function (name) {
            var gotoIndex = 0;
            var views = _this.state.views;
            views.forEach(function (view, index) {
                if (view.title === name) {
                    gotoIndex = index;
                }
            });
            _this.goto(gotoIndex);
        };
        _this.renderCloseButton = function () { return (React.createElement(Button, { className: "btn-close", transparent: true, onClick: _this.close },
            React.createElement(Icon, { name: "close" }))); };
        _this.myRef = React.createRef();
        _this.targetElement = null;
        var component = _this;
        var elementProps = __assign({ router: component });
        var element = React.Children.map(props.children, function (view) { return React.cloneElement(view, elementProps); });
        _this.state = {
            modalControl: props.open ? 'md-modal md-show' : 'md-modal',
            open: props.open,
            views: [{ element: element, title: props.title, disableTitle: props.disableTitle, overflow: props.overflow, customHeader: props.customHeader, closeOnDimmerClick: props.closeOnDimmerClick, disableCloseButton: props.disableCloseButton }],
        };
        return _this;
    }
    NavigationControllerModal.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.open) {
            document.body.classList.add('md-open');
            disableBodyScroll(document.querySelector('#modal-wrapper'));
        }
        if (nextProps.open !== prevState.open) {
            return {
                modalControl: nextProps.open ? 'md-modal md-show' : 'md-modal',
                open: nextProps.open,
            };
        }
        return null;
    };
    NavigationControllerModal.prototype.componentDidMount = function () {
        this.targetElement = document.querySelector('#modal-wrapper');
    };
    NavigationControllerModal.prototype.componentWillUnmount = function () {
        document.body.classList.remove('md-open');
        clearAllBodyScrollLocks();
    };
    NavigationControllerModal.prototype.push = function (_a) {
        var component = _a.component, title = _a.title, _b = _a.disableTitle, disableTitle = _b === void 0 ? false : _b, _c = _a.overflow, overflow = _c === void 0 ? false : _c, _d = _a.customHeader, customHeader = _d === void 0 ? false : _d, _e = _a.closeOnDimmerClick, closeOnDimmerClick = _e === void 0 ? true : _e, _f = _a.disableCloseButton, disableCloseButton = _f === void 0 ? false : _f;
        var element = React.cloneElement(component, { router: this });
        var views = this.state.views;
        views.push({ element: element, title: title, disableTitle: disableTitle, overflow: overflow, customHeader: customHeader, closeOnDimmerClick: closeOnDimmerClick, disableCloseButton: disableCloseButton });
        this.setState({ views: views });
    };
    NavigationControllerModal.prototype.replace = function (_a) {
        var component = _a.component, title = _a.title, _b = _a.disableTitle, disableTitle = _b === void 0 ? false : _b, _c = _a.overflow, overflow = _c === void 0 ? false : _c, _d = _a.customHeader, customHeader = _d === void 0 ? false : _d, _e = _a.closeOnDimmerClick, closeOnDimmerClick = _e === void 0 ? true : _e, _f = _a.disableCloseButton, disableCloseButton = _f === void 0 ? false : _f;
        var element = React.cloneElement(component, { router: this });
        this.setState({
            views: [
                {
                    element: element,
                    title: title,
                    disableTitle: disableTitle,
                    customHeader: customHeader,
                    overflow: overflow,
                    closeOnDimmerClick: closeOnDimmerClick,
                    disableCloseButton: disableCloseButton,
                },
            ],
        });
    };
    NavigationControllerModal.prototype.getBreadcrumb = function () {
        var _this = this;
        var views = this.state.views;
        var crumbs = views.map(function (_a, i) {
            var title = _a.title;
            return (React.createElement(BreadcrumbSection, { key: 'section_' + i },
                React.createElement(Button, { transparent: true, onClick: function () { return _this.goto(i); } }, title)));
        });
        return (React.createElement(Breadcrumb, null, crumbs.map(function (crumb, i) { return [
            crumb,
            i < crumbs.length - 1 && React.createElement(BreadcrumbDivider, { key: 'divider_' + i, icon: "right angle" }),
        ]; })));
    };
    NavigationControllerModal.prototype.getCurrentView = function () {
        return this.state.views[this.state.views.length - 1];
    };
    NavigationControllerModal.prototype.render = function () {
        var currentView = this.getCurrentView();
        var classNames = [this.state.modalControl, this.props.className ? this.props.className : ''].filter(function (x) { return x; });
        if (!this.props.size) {
            classNames.push('md-normal');
        }
        else if (this.props.size === ModalSize.SMALL) {
            classNames.push('md-small');
        }
        else if (this.props.size === ModalSize.MEDIUM) {
            classNames.push('md-medium');
        }
        else if (this.props.size === ModalSize.LARGE) {
            classNames.push('md-large');
        }
        else if (this.props.size === ModalSize.FULLSCREEN) {
            classNames.push('md-fullscreen');
        }
        else if (this.props.size === ModalSize.FULLHEIGHT) {
            classNames.push('md-fullheight');
        }
        else if (this.props.size === ModalSize.FIXSMALLHEIGHT) {
            classNames.push('md-fixsmallheight');
        }
        else if (this.props.size === ModalSize.SCROLLABLE) {
            classNames.push('md-scrollable');
        }
        if (this.props.overflow) {
            classNames.push('md-allow-overflow');
        }
        return (React.createElement(Styled, { id: this.props.id, className: "" + classNames.join(' ') },
            React.createElement("div", { className: "md-container", tabIndex: 0, ref: this.myRef, onKeyDown: currentView.closeOnDimmerClick ? this.handleKeyPress : undefined },
                React.createElement("div", { className: this.state.modalControl },
                    React.createElement("div", { className: "md-wrapper", id: "modal-wrapper" },
                        !currentView.customHeader &&
                            React.createElement(React.Fragment, null, currentView.disableTitle === false ? (React.createElement("div", { className: "" + (this.props.centerTitle ? 'md-title title-center' : 'md-title') + (this.props.closeButtonPosition === CloseButtonPosition.LEFT ? ' left-sided' : ' right-sided') },
                                this.getBreadcrumb(),
                                !currentView.disableCloseButton ? this.renderCloseButton() : null)) : (React.createElement("div", { className: "md-no-title" + (this.props.closeButtonPosition === CloseButtonPosition.LEFT ? ' left-sided' : ' right-sided') }, !currentView.disableCloseButton ? this.renderCloseButton() : null))),
                        React.createElement("div", { className: "md-content" }, currentView.element))),
                React.createElement("div", { className: "md-overlay", onClick: currentView.closeOnDimmerClick ? this.close : undefined }))));
    };
    NavigationControllerModal.defaultProps = {
        disableCloseButton: false,
        closeOnDimmerClick: true,
        centerTitle: false,
        closeButtonPosition: CloseButtonPosition.RIGHT,
        disableTitle: false,
        overflow: false,
        customHeader: false,
    };
    return NavigationControllerModal;
}(React.Component));
export { NavigationControllerModal };
export default NavigationControllerModal;
//# sourceMappingURL=index.js.map